import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import * as UI from '../Common.styles'
import Media from 'components/common/Media'
import { BazaarVoiceRating } from 'components/common/Rating'
import Theme from 'components/common/Theme/Theme'
import { A } from 'components/common/Link/Link'
import CompatibilityLabel from 'components/common/CompatibilityLabel'
import PhoneLink from 'components/common/PhoneLink'
import { formatPrice } from 'helpers/utils'
import { CALL_STORE_FOR_PRICE_FIRST_TEXT } from 'constant'


const Product = ({
  price,
  className,
  compatibilityStatus,
  handleAddNewVehicle,
  hasStore,
  hasMapPrice,
  seePriceIncartMessage,
  imageUrl,
  name,
  showCompatibility,
  showStoreLocatorModal,
  url,
  vehicleName,
  isShowCallStoreForPrice,
  isShowPrice,
  isShowStartingAtPrice,
  formattedStorePhoneNumber,
  storePhoneNumber,
  mapShowPhoneNumber,
  bvId,
  reviewsLink
}) =>
  <UI.Block className={ className } data-at-globalsearch-product>
    <UI.Table>
      <UI.Image data-at-globalsearch-image src={ imageUrl } alt={ name } />
      <UI.Info>
        <UI.Name to={ url } data-at-globalsearch-product-name>{ name }</UI.Name>
        {
          hasMapPrice && hasStore && !isShowCallStoreForPrice &&
            <UI.Price data-at-globalsearch-product-price>
              { seePriceIncartMessage }
              { mapShowPhoneNumber &&
                <React.Fragment>
                  <Media.Desktop><Phone>{ formattedStorePhoneNumber }</Phone></Media.Desktop>
                  <Media.Mobile><StyledPhoneLink number={ storePhoneNumber } /></Media.Mobile>
                </React.Fragment>
              }
            </UI.Price>
        }
        {
          isShowPrice && !hasMapPrice &&
            <UI.Price data-at-globalsearch-product-price>{ formatPrice(price) } /each</UI.Price>
        }
        {
          isShowCallStoreForPrice &&
          <UI.Price data-at-globalsearch-product-price>
            { CALL_STORE_FOR_PRICE_FIRST_TEXT }
            <Media.Desktop><Phone>{ formattedStorePhoneNumber }</Phone></Media.Desktop>
            <Media.Mobile><StyledPhoneLink number={ storePhoneNumber } /></Media.Mobile>
          </UI.Price>
        }
        {
          isShowStartingAtPrice && !hasMapPrice &&
            <UI.Price data-at-globalsearch-product-price>Starting at { formatPrice(price) }</UI.Price>
        }
        {
          !hasStore &&
            <SelectStore data-at-globalsearch-product-price bolder prevent handler={ showStoreLocatorModal }>
              Select Store For Price
            </SelectStore>
        }
        {
          showCompatibility &&
            <CompatibilityLabel
              status={ compatibilityStatus }
              handleAddNewVehicle={ handleAddNewVehicle }
              vehicle={ vehicleName } />
        }
        <CustomRating
          smallest
          bvId={ bvId }
          reviewName={ name }
          reviewsLink={ reviewsLink }
          showRatingMax
          hideReviewText />
      </UI.Info>
    </UI.Table>
  </UI.Block>

Product.propTypes = {
  bvId: PropTypes.string,
  className: PropTypes.string,
  compatibilityStatus: PropTypes.string,
  formattedStorePhoneNumber: PropTypes.string,
  handleAddNewVehicle: PropTypes.func,
  hasMapPrice: PropTypes.bool,
  hasStore: PropTypes.bool,
  imageUrl: PropTypes.string,
  isShowCallStoreForPrice: PropTypes.bool,
  isShowPrice: PropTypes.bool,
  isShowStartingAtPrice: PropTypes.bool,
  mapShowPhoneNumber: PropTypes.bool,
  name: PropTypes.string,
  price: PropTypes.string,
  reviewsLink: PropTypes.string,
  seePriceIncartMessage: PropTypes.string,
  showCompatibility: PropTypes.bool,
  showStoreLocatorModal: PropTypes.func,
  storePhoneNumber: PropTypes.string,
  url: PropTypes.string,
  vehicleName: PropTypes.string
}

export default Product

const SelectStore = styled(A)`
  margin: 5px 0;
`

const CustomRating = styled(BazaarVoiceRating)`
  color: ${Theme.colors.black};
`

const Phone = styled.div`
  font-weight: 700;
`

const StyledPhoneLink = styled(PhoneLink)`
  display: block;
  font-weight: 700;
`
